import { render } from "./tw-ws-container.vue?vue&type=template&id=cebb8d6c"
import script from "./tw-ws-container.vue?vue&type=script&lang=js"
export * from "./tw-ws-container.vue?vue&type=script&lang=js"
script.render = render

export default script